import { API_HOST } from 'src/constants/config'

export const GRAPHQL_API = `${API_HOST}/graphql`
